var map = {
	"./anxious.png": 387,
	"./appetite.png": 388,
	"./appetite_loss.png": 389,
	"./appointment.png": 390,
	"./body_ache.png": 391,
	"./chest.png": 392,
	"./chills.png": 393,
	"./congestion.png": 394,
	"./constipation.png": 395,
	"./decreased_concentration.png": 396,
	"./diarrhea.png": 397,
	"./dizziness.png": 398,
	"./dryness.png": 399,
	"./exercise.png": 400,
	"./fatigue.png": 401,
	"./fever.png": 402,
	"./general_pain.png": 403,
	"./group.png": 404,
	"./headache.png": 405,
	"./loss_of_smell.png": 406,
	"./medication.png": 407,
	"./mood.png": 408,
	"./mouth_dryness.png": 409,
	"./nausea.png": 410,
	"./notes.png": 411,
	"./notification.png": 412,
	"./nutrition.png": 413,
	"./runny_nose.png": 414,
	"./shortness_of_breath.png": 415,
	"./sleep.png": 416,
	"./telephone.png": 417,
	"./today.png": 418,
	"./treatment.png": 419,
	"./undefined.png": 157,
	"./underarm.png": 420,
	"./vomiting.png": 421,
	"./weight.png": 422
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 156;


//////////////////
// WEBPACK FOOTER
// ./src/icons/symptoms ^\.\/.*\.png$
// module id = 156
// module chunks = 0